import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {GeoICONS} from "../core/components/icon/icon";
import {SemanticCOLORS} from "semantic-ui-react";


@JsonObject()
export class ProcessStatusConfiguration {

    /**
     * Unique Identifier
     */
    @JsonProperty()
    declare id: number;

    /**
     * Name of the process state
     * Describes the state
     */
    @JsonProperty()
    declare name: string;

    /**
     * The label used in process tree
     */
    @JsonProperty()
    declare label: string;

    /**
     * In cases where 'canClick' = true, the actionLabel have to be specified
     * Usually describes the action needed to go to this state
     */
    @JsonProperty()
    declare actionLabel: string;

    /**
     * Description of this state
     */
    @JsonProperty()
    declare description: string;

    /**
     * Visibility of status in process tree
     */
    declare visibility: "visible" | "hidden";

    /**
     * The icon displayed for this status
     */
    @JsonProperty()
    declare icon: GeoICONS;

    /**
     * If this process status can be manually selected
     */
    @JsonProperty()
    declare canClick: boolean;

    /**
     * Status type
     *
     * error: status only shows when process has this status
     * long-running: long-running task, shows spinner
     */
    @JsonProperty()
    declare type: "error" | "long-running";

    /**
     * Name of the process cycle, this status belongs to
     * Is used to group status together that can be passed multiple times in a sub-cycle
     */
    @JsonProperty()
    declare cycle: string;

    /**
     * If this state indicates the start of the process
     * Only one start status allowed.
     * Takes first found start status if multiple are defined.
     */
    @JsonProperty()
    declare isStart: boolean;

    /**
     * If this state indicates the end of the process
     * Multiple closing states are valid for a process
     */
    @JsonProperty()
    declare isClosed: boolean;

    /**
     * If project properties can be changed on this status
     */
    @JsonProperty()
    declare canChangeProject: boolean;

    /**
     * Color of the state (can be used to display state in UI in different colors
     */
    @JsonProperty()
    declare color: SemanticCOLORS;

    constructor() {
    }

    /**
     * If the state stands for an error
     */
    get isError(): boolean {
        return this.type === "error";
    }

    static sortByName(a: ProcessStatusConfiguration, b: ProcessStatusConfiguration) {
        const nameA = a.name;
        const nameB = b.name;
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // types must be equal
        return 0;
    }

    static sortByStatus(a: ProcessStatusConfiguration, b: ProcessStatusConfiguration) {
        const nameA = a.id;
        const nameB = b.id;
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // types must be equal
        return 0;
    }
}
